export const TEMPLATE_SIGNUP_ENDPOINT = '/api/public/index.php?route=v1/templates/signup';

export async function submitTemplateSignup(fetchImpl, values) {
  const response = await fetchImpl(TEMPLATE_SIGNUP_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({
      email: values.email.trim(),
      website_url: values.website_url || '',
      source: values.source || 'rankerd_templates',
      landing_page: values.landing_page || window.location.pathname,
      referrer: values.referrer || document.referrer,
      utm_source: values.utm_source || '',
      utm_medium: values.utm_medium || '',
      utm_campaign: values.utm_campaign || '',
      utm_content: values.utm_content || '',
    }),
  });
  const body = await response.json().catch(() => ({}));
  return { ok: response.ok && body.success === true, response, body };
}
